module.exports = __webpack_public_path__ + "img/character_cv.448ff686.png";